<!-- header -->
<app-header></app-header>

<!-- full outlet -->
<section class="content">
  @if (this.userService?.userInfo?.documentsToAccept?.length > 0) {
    <app-modal-privacy-policy [documents]="this.userService?.userInfo?.documentsToAccept"></app-modal-privacy-policy>
  } @else {
    <router-outlet></router-outlet>
  }
</section>

<!-- footer -->
<app-footer></app-footer>

<!-- Custom Notification Controller -->
<toast-notification></toast-notification>
